// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import React from "react";

const IconExcel = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="16" viewBox="0 0 12 16">
            <path
                fill="currentColor"
                d="M7,4 L7,0 L1.5,0 C0.671562672,0 0,0.671562195 0,1.5 L0,14.5 C0,15.328125 0.671562672,16 1.5,16 L10.5,16 C11.3284378,16 12,15.3284378 12,14.5 L12,5 L8.02812481,5 C7.4468751,5 7,4.55312538 7,4 Z M8.50312519,8.26249981 L7,10.75 L8.53093719,13.237812 C8.73750019,13.5718746 8.49687481,14 8.10624981,14 L7.28031254,14 C7.10665607,14 6.94562483,13.9099064 6.85437489,13.7619686 L6,12.375 L5.14656258,13.7618752 C5.0562501,13.9093752 4.89375019,14 4.72187519,14 L3.89374971,14 C3.50249958,14 3.26281166,13.5709372 3.46781206,13.237812 L4.99999952,10.75 L3.46874952,8.26249981 C3.26249933,7.9281249 3.50312424,7.5 3.89374924,7.5 L4.71968699,7.5 C4.89334345,7.5 5.05437469,7.59009361 5.14562464,7.73790646 L5.99999952,9.125 L6.85343695,7.73781252 C6.94374943,7.59062481 7.10624933,7.5 7.27812433,7.5 L8.1040616,7.5 C8.49687433,7.5 8.73749971,7.9281249 8.50312471,8.26249981 L8.50312519,8.26249981 Z M7.99999952,0 L7.99999952,4 L11.9999995,4 L7.99999952,0 Z"
            />
        </svg>
    );
};

export default IconExcel;
